import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login, getToken, getRole, getSocioId } from "../services/auth";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Si ya hay token, sal del login
  useEffect(() => {
    const t = getToken();
    if (t) {
      const rol = getRole();
      const sid = getSocioId();
      navigate(rol === "socio" && sid ? `/socios/${sid}` : "/", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password, remember); // redirige desde auth.js
      // por si el navegador bloquea el replace (muy raro), fallback:
      setTimeout(() => setLoading(false), 1500);
    } catch (err) {
      setError("Usuario o contraseña incorrectos");
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gray-100">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-2xl shadow-lg w-96">
        <h1 className="text-2xl font-bold mb-6 text-center">Iniciar sesión</h1>

        <label className="block text-sm mb-2">Usuario</label>
        <input
          className="w-full border p-2 rounded mb-4"
          placeholder="Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
        />

        <label className="block text-sm mb-2">Contraseña</label>
        <input
          className="w-full border p-2 rounded mb-4"
          placeholder="Contraseña"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <label className="flex items-center gap-2 text-sm mb-4">
          <input
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />
          Mantener sesión iniciada
        </label>

        {error && <p className="text-red-500 mb-4">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-60"
        >
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
